import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
  useMediaQuery,
} from "@mui/material";
import ImageDataUrlContextProvider from "./context/ImageDataUrlContext";
import GameDataContextProvider from "./context/GameDataContext";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GamesOverviewPage from "./pages/GamesOverviewPage";
import GameChallengeView from "./pages/GameChallengeView";
import AppDataContextProvider from "./context/AppContext";
import GameRefereeTabletView from "./pages/GameRefereeTabletView";
import ResponsiveContextProvider from "./context/ResponsiveContext";
import SocketIoWrapper from "./context/SocketIoWrapper";
import ActionBookmarksContextProvider from "./context/ActionBookmarksContext";
import { TabManagementContextProvider } from "@context/TabManagementContext";

const secondary = {
  light: "#ffaf7a",
  main: "#ff9b59",
  dark: "#b26c3e",
  contrastText: "#fff",
};
const primary = {
  light: "#3381ac",
  main: "#006298",
  dark: "#00446a",
  contrastText: "#fff",
};

let lightTheme = createTheme({
  palette: {
    mode: "light",
    primary,
    secondary,
  },
});
lightTheme = responsiveFontSizes(lightTheme, { factor: 3 });

let darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary,
    secondary,
  },
  components: {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": { color: "#00a4ff", backgroundColor: "#0e20615e" },
        },
      },
    },
  },
});
darkTheme = responsiveFontSizes(darkTheme, { factor: 3 });

const App = () => {
  const useDarkTheme = useMediaQuery("(prefers-color-scheme: dark)");

  return (
    <ThemeProvider theme={useDarkTheme ? darkTheme : lightTheme}>
      <BrowserRouter>
        <ResponsiveContextProvider>
          <TabManagementContextProvider>
            <AppDataContextProvider>
              <ImageDataUrlContextProvider>
                <GameDataContextProvider>
                  <ActionBookmarksContextProvider>
                    {/*<TickerContextProvider>*/}
                    <SocketIoWrapper>
                      <Routes>
                        <Route index element={<GamesOverviewPage />} />
                        <Route
                          path={"/game/:scope/:samsId/challenge-view"}
                          element={<GameChallengeView />}
                        />
                        <Route
                          path={"/game/:scope/:samsId/referee-tablet"}
                          element={<GameRefereeTabletView />}
                        />
                      </Routes>
                    </SocketIoWrapper>
                    {/*</TickerContextProvider>*/}
                  </ActionBookmarksContextProvider>
                </GameDataContextProvider>
              </ImageDataUrlContextProvider>
            </AppDataContextProvider>
          </TabManagementContextProvider>
        </ResponsiveContextProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
